import store from '../store'


export const authGuard = (to, from, next) => {

    if (store.getters['auth/isAuthenticated']) {

        if(to.name === "login") {
            next('/');
        }else{
            next();
        }
    }else{

        if(to.name === "login") {
            next();
        }else{
            next('/login');
        }
    }

};